import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import TalentDirectoryPage from "@/pages/admin/TalentDirectoryPage";

export const Route = createFileRoute("/_admin/admin/talent-directory")({
  head: () => pageHead("Admin · Talent Directory", "AKIVA admin · talent directory portal.", "/admin/talent-directory", true),
  component: TalentDirectoryPage,
});
